export default __webpack_public_path__ + "static/media/iso.c40b4484.jpg";